// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13XO6","title":"Info_title__2apFK","selects":"Info_selects__38Ii-","requiredAsterisk":"Info_requiredAsterisk__1yiRx"};